module.exports = __webpack_public_path__ + "static/media/logo.5148f7e6.svg";